import { useEffect } from "react";
import { Link } from "react-router-dom";
import BuyerChecklistFull from "../../components/automap/buyerChecklist/BuyerChecklistFull";
import { CHECKLIST_DISCLAIMER_ES } from "../../constants/buyerChecklistConstants";
import { trackBuyerChecklistEvent } from "../../constants/buyerChecklistConstants";
import "../../styles/buyerChecklist.css";

const COMMON_MISTAKES = [
  "Pagar anticipos sin ver el vehículo ni revisar documentos.",
  "Confiar solo en fotos sin inspección presencial o mecánica.",
  "No confirmar SOAT, tecnomecánica, multas y limitaciones de dominio.",
  "Negociar sin comparar precio con publicaciones similares.",
  "Firmar o transferir sin acuerdos claros por escrito.",
];

const RED_FLAGS = [
  "Presión para pagar rápido o por fuera de canales formales.",
  "Precio muy por debajo del mercado sin explicación razonable.",
  "Datos que cambian entre anuncio, WhatsApp y visita.",
  "Rechazo a inspección mecánica independiente.",
  "Cuentas bancarias personales no verificadas.",
];

const DEALER_QUESTIONS = [
  "¿El vehículo sigue disponible hoy?",
  "¿Puedo ver tarjeta de propiedad, SOAT y tecnomecánica?",
  "¿Hay multas, comparendos o gravámenes pendientes?",
  "¿Aceptan inspección mecánica externa?",
  "¿Qué incluye el precio publicado?",
  "¿Cuál es el proceso y costo estimado de traspaso?",
];

export default function BuyerChecklistGuidePage() {
  useEffect(() => {
    trackBuyerChecklistEvent("buyer_checklist_page_viewed", { page: "guide" });
    document.title = "Checklist para comprar carro usado en Colombia | AutoMapa";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Revisa documentos, SOAT, tecnomecánica, precio, inspección mecánica, traspaso y pagos antes de comprar un carro usado."
      );
    }
  }, []);

  return (
    <div className="buyer-checklist-page">
      <header className="buyer-checklist-page__hero">
        <div className="wrap">
          <span className="buyer-checklist-page__eyebrow">Guía AutoMapa</span>
          <h1>Checklist para comprar carro usado en Colombia</h1>
          <p>
            Una guía práctica para revisar documentos, estado del vehículo, precio, pagos y traspaso
            antes de tomar una decisión de compra.
          </p>
        </div>
      </header>

      <main className="buyer-checklist-page__main buyer-checklist-guide">
        <section className="buyer-checklist-guide__section">
          <h2>Por qué usar una checklist</h2>
          <p>
            Comprar un carro usado implica verificar disponibilidad, documentos, estado mecánico,
            precio y condiciones de pago. Una checklist te ayuda a no omitir pasos importantes y a
            llegar mejor preparado a la conversación con el concesionario.
          </p>
        </section>

        <section className="buyer-checklist-guide__section">
          <h2>Checklist completa</h2>
          <BuyerChecklistFull showImportance />
        </section>

        <section className="buyer-checklist-guide__section">
          <h2>Errores comunes</h2>
          <ul>
            {COMMON_MISTAKES.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="buyer-checklist-guide__section">
          <h2>Señales de alerta</h2>
          <ul>
            {RED_FLAGS.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="buyer-checklist-guide__section">
          <h2>Qué preguntar al concesionario</h2>
          <ul>
            {DEALER_QUESTIONS.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="buyer-checklist-guide__section" id="payment">
          <h2>Qué verificar antes de pagar</h2>
          <p>
            Confirma identidad del vendedor, documentos del vehículo, resultado de inspección mecánica,
            acuerdo de precio final, medios de pago trazables y pasos de traspaso. No entregues el
            saldo completo sin claridad documental.
          </p>
        </section>

        <section className="buyer-checklist-guide__section">
          <h2>Cómo ayuda AutoMapa</h2>
          <p>
            AutoMapa organiza inventario de concesionarios, señales de precio justo, indicadores de
            revisión y reportes de compradores. Estas herramientas orientan tu decisión, pero no
            reemplazan peritaje, asesoría legal ni validación oficial.
          </p>
          <p>
            <Link to="/seguridad">Ver guía de seguridad</Link>
            {" · "}
            <Link to="/guias/compra-segura">Guía de compra segura</Link>
          </p>
        </section>

        <div className="buyer-checklist-guide__cta-row">
          <Link to="/v/automap/vehicles" className="buyer-checklist-btn buyer-checklist-btn--primary">
            Buscar vehículos
          </Link>
          <Link to="/v/automap/comprar/quiz" className="buyer-checklist-btn buyer-checklist-btn--soft">
            Usar quiz del comprador
          </Link>
          <Link to="/checklist-compra" className="buyer-checklist-btn buyer-checklist-btn--soft">
            Checklist rápida
          </Link>
        </div>

        <p className="buyer-checklist-disclaimer">{CHECKLIST_DISCLAIMER_ES}</p>
      </main>
    </div>
  );
}
